export const SESSION_REDIRECT_KEY = 'mycanvas.signin.redirect';
